const serviceRoot = '/api/users/';

export const UserRoleCapabilityEndpoints = {
  getUserRoleCapabilities: () => `${serviceRoot}capabilities`,
};
